import {
  REQUEST_ORDER_RECOVERY_SEARCH,
  REQUEST_ORDER_RECOVERY_SEARCH_SUCCEEDED,
  REQUEST_ORDER_RECOVERY_SEARCH_FAILED,
  REQUEST_ORDER_RECOVERY_RECOVER,
  REQUEST_ORDER_RECOVERY_RECOVER_SUCCEEDED,
  REQUEST_ORDER_RECOVERY_RECOVER_FAILED,
  REQUEST_ORDER_RECOVERY_CHANGE_STATUS,
  REQUEST_ORDER_RECOVERY_CHANGE_STATUS_SUCCEEDED,
  REQUEST_ORDER_RECOVERY_CHANGE_STATUS_FAILED,
} from './action-types';
import utils from '../utils';

const initialState = {
  data: [],
  pages: 0,
  loading: false,
  reload: false,
};

const orderRecoveryReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case REQUEST_ORDER_RECOVERY_SEARCH:
    case REQUEST_ORDER_RECOVERY_RECOVER:
    case REQUEST_ORDER_RECOVERY_CHANGE_STATUS:
      return {
        ...state,
        loading: true,
        reload: false,
      };
    case REQUEST_ORDER_RECOVERY_SEARCH_SUCCEEDED: {
      const { data, pages } = action;
      return {
        ...state,
        data,
        pages,
        loading: false,
        reload: false,
      };
    }
    case REQUEST_ORDER_RECOVERY_SEARCH_FAILED: {
      utils.dialog({
        type: 'warning',
        title: 'Error inesperado',
        message: 'No se ha podido recuperar el listado de matriculas pendientes',
      });
      return {
        ...state,
        loading: false,
        reload: false,
      };
    }
    case REQUEST_ORDER_RECOVERY_RECOVER_SUCCEEDED: {
      utils.dialog({
        type: 'succes',
        title: 'Todo ha ido bien',
        message: 'La matrícula se ha recuperado correctamente',
      });
      return {
        ...state,
        loading: false,
        reload: true,
      };
    }
    case REQUEST_ORDER_RECOVERY_RECOVER_FAILED: {
      utils.dialog({
        type: 'warning',
        title: 'Error inesperado',
        message: 'La matrícula no se ha podido generar',
      });
      return {
        ...state,
        loading: false,
        reload: false,
      };
    }
    case REQUEST_ORDER_RECOVERY_CHANGE_STATUS_SUCCEEDED: {
      utils.dialog({
        type: 'succes',
        title: 'Todo ha ido bien',
        message: 'La matrícula ha cambiado de estado y ahora se puede recuperar',
      });
      return {
        ...state,
        loading: false,
        reload: true,
      };
    }
    case REQUEST_ORDER_RECOVERY_CHANGE_STATUS_FAILED: {
      utils.dialog({
        type: 'warning',
        title: 'Error inesperado',
        message: 'La matrícula no se ha podido cambiar de estado',
      });
      return {
        ...state,
        loading: false,
        reload: false,
      };
    }
    default:
      return state;
  }
};

export default orderRecoveryReducer;
